import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { Guest } from '@tv3/store/guest/guest.model'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { ConnectWhatsappDialogComponent } from './connect-whatsapp-dialog.component'

@Injectable()
export class ConnectWhatsappDialogService {
  constructor(private dialog: MatDialog) {}

  public open(guest: Guest, inquiry?: Inquiry) {
    const defaultConfig: MatDialogConfig = {
      width: '650px',
      height: 'auto',
      panelClass: ['fixed-modal', 'no-scroll-modal'],
      data: { guest, inquiry },
    }

    return this.dialog.open(ConnectWhatsappDialogComponent, defaultConfig)
  }
}
